import { Component, inject, input } from '@angular/core';
import { DialogService } from '@core/services';
import { BaseComponent } from '@shared/classes';
import { ButtonComponent } from '@shared/components/button/button.component';
import { BurnRewardModalComponent } from '@shared/components/modals/burn-reward-modal/burn-reward-modal.component';
import { TermsAndConditionsModalComponent } from '@shared/components/modals/terms-and-conditions-modal/terms-and-conditions-modal.component';
import { Reward } from '@shared/factory';
import { RewardFirstVariant } from '@shared/models';
import { SafePipe, VariableReplacementPipe } from '@shared/pipes';
@Component({
  selector: 'b2c-variant1',
  styleUrl: './variant1.component.scss',
  templateUrl: './variant1.component.html',
  imports: [SafePipe, ButtonComponent, VariableReplacementPipe],
})
export class Variant1Component extends BaseComponent {
  reward = input.required<Reward>();
  config = input.required<RewardFirstVariant>();

  private readonly dialog: DialogService = inject(DialogService);

  onSelectReward(): void {
    this.dialog.open(BurnRewardModalComponent, {
      data: this.reward(),
      anchorToBottom: true,
    });
  }

  showTermsAndConditions(): void {
    this.dialog.open(TermsAndConditionsModalComponent, {
      data: this.reward().termsAndConditions,
      anchorToBottom: true,
    });
  }
}
